import { Component, Input } from '@angular/core';

@Component({
    selector: 'swipesum-footer',
    templateUrl: './swipesum-footer.component.html',
    styleUrls: ['./swipesum-footer.component.scss'],
    standalone: false
})
export class SwipesumFooterComponent {
    @Input() appName: string = 'Swipesum';

    constructor() { }

    ngOnInit(): void {
    }

    getYearForCopyright(): string {
        return new Date().getFullYear().toString();
    }
}